module.exports = __webpack_public_path__ + "img/facebook.146b6999.png";